/* DR. BALI — homepage editorial flow: manifesto + "Kendi ritminiz" motion.
   Loaded (defer) by the Manifesto section. Quiet, one-time reveals; a slow
   parallax on the ritim photograph (desktop only). Nothing moves when the
   visitor prefers reduced motion or ?motion=off is used. */
(function () {
  'use strict';

  var root = document.documentElement;
  var mq = function (q) { return window.matchMedia && window.matchMedia(q).matches; };
  var still = mq('(prefers-reduced-motion: reduce)') ||
    window.location.search.indexOf('motion=off') !== -1 ||
    !('IntersectionObserver' in window);

  // Stable anchor for links into the care-layer chapter (e.g. from the mega menu).
  function anchorLayering() {
    var layering = document.querySelector('.drbali-layering');
    if (!layering) return;
    var anchor = document.getElementById('bakim-katmani');
    if (!anchor) {
      anchor = document.createElement('span');
      anchor.id = 'bakim-katmani';
      anchor.setAttribute('aria-hidden', 'true');
      layering.parentNode.insertBefore(anchor, layering);
    }
    if (window.location.hash === '#bakim-katmani') {
      anchor.scrollIntoView({ block: 'start', behavior: still ? 'auto' : 'smooth' });
    }
  }

  function init() {
    try { anchorLayering(); } catch (e) { /* navigation aid only */ }
    var manifesto = document.querySelector('.drbali-manifesto');
    var ritim = document.querySelector('.drbali-ritim');
    if (!manifesto && !ritim) return;

    if (still) {
      if (manifesto) manifesto.classList.add('dm-manifesto-in');
      return;
    }

    var targets = [];
    var vh = window.innerHeight || root.clientHeight;
    function mark(el, kind, delay) {
      if (!el) return;
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.92 && r.bottom > 0) return; // already on screen: leave it
      el.setAttribute('data-flow', kind);
      el.style.setProperty('--flow-delay', delay + 'ms');
      targets.push(el);
    }

    if (manifesto) {
      mark(manifesto.querySelector('.drbali-manifesto__eyebrow'), 'up', 0);
      mark(manifesto.querySelector('.drbali-manifesto__body'), 'up', 420);
    }
    if (ritim) {
      mark(ritim.querySelector('.drbali-ritim__frame'), 'rise', 0);
      mark(ritim.querySelector('.drbali-ritim__line--a'), 'up', 120);
      mark(ritim.querySelector('.drbali-ritim__line--b'), 'up', 260);
      mark(ritim.querySelector('.drbali-ritim__aside'), 'up', 200);
    }

    root.classList.add('dm-flow');

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-flow-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
    targets.forEach(function (el) { io.observe(el); });

    if (manifesto) {
      var thread = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        manifesto.classList.add('dm-manifesto-in');
        thread.disconnect();
      }, { threshold: 0.15 });
      thread.observe(manifesto);
    }

    // Slow parallax inside the ritim frame: desktop with a fine pointer only.
    var frame = ritim && ritim.querySelector('.drbali-ritim__frame');
    var img = frame && frame.querySelector('img');
    if (!img || !mq('(min-width: 990px)') || !mq('(hover: hover) and (pointer: fine)')) return;

    img.style.scale = '1.12';
    var ticking = false;
    var visible = false;

    function update() {
      ticking = false;
      if (!visible) return;
      var h = window.innerHeight || root.clientHeight;
      var r = frame.getBoundingClientRect();
      var p = (r.top + r.height / 2 - h / 2) / (h / 2 + r.height / 2);
      p = Math.max(-1, Math.min(1, p));
      img.style.translate = '0 ' + (-p * r.height * 0.05).toFixed(1) + 'px';
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    new IntersectionObserver(function (entries) {
      visible = entries[0].isIntersecting;
      if (visible) onScroll();
    }).observe(frame);

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
